import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './navigation-component.scss.js';
import img$1 from '../../../../assets/images/icon-menu.svg.js';
import img from '../../../../assets/images/icon-close.svg.js';
import { disableBodyScroll, enableBodyScroll, debounce } from '../../../../../../Convatec.Dxp.Feature.GlobalContent/WebComponents/src/components/utilities/behavior-helpers/index.js';
import '../../../../../../Convatec.Dxp.Feature.GlobalContent/WebComponents/src/components/utilities/dom-helpers/index.js';

function getShift(el1, el2) {
    return Math.ceil(el1.getBoundingClientRect().top - el2.getBoundingClientRect().height);
}
class amcareMainNav extends s {
    constructor() {
        super(...arguments);
        this.mobileMenuIsOpen = false;
        this.isMobile = false;
        this.isAuthorized = false;
        this.header = null;
        this.alertBanner = null;
        this.alertBannerInner = null;
        this.heroBlock = null;
        this.pusher = null;
        this.breadcrumb = null;
        this.content = null;
        this.top = null;
        this.closeButtonText = 'Close Menu';
        this.openMenuText = 'Open Menu';
        this.setNegativeMargin = (shift) => {
            this.top.style.top = shift < 0 ? `${shift}px` : '0px';
        };
        this.handleScroll = () => {
            if (!this.pusher)
                return;
            const mainMenu = this.shadowRoot.querySelector('nav');
            const shift = getShift(this.pusher, this.top);
            if (shift > -this.top.offsetHeight && shift < 0) {
                this.setNegativeMargin(shift);
            }
            else {
                this.top.style.top = '';
            }
            if (this.top.offsetHeight + shift <= 0) {
                mainMenu.classList.add('condensed');
                this.top.classList.add('sticky');
                setTimeout(() => {
                    this.top.classList.add('reveal');
                }, 10);
                return;
            }
            if (this.top.offsetHeight + shift > 0) {
                this.top.classList.remove('reveal');
                mainMenu.classList.remove('condensed');
                this.top.classList.remove('sticky');
            }
        };
    }
    // eslint-disable-next-line sonarjs/cognitive-complexity
    firstUpdated() {
        setTimeout(() => {
            this.header = document.querySelector('header');
            this.content = document.querySelector('.content');
            this.top = document.querySelector('.top');
            this.heroBlock = document.querySelector('full-image-video');
            if (this.top && this.content && this.heroBlock) {
                this.requestUpdate();
            }
            this.pusher = this.heroBlock
                ? this.heroBlock.shadowRoot.querySelector('.after')
                : this.content;
        }, 0);
        if (this.shadowRoot) {
            // Groups
            const dropdownTriggers = this.shadowRoot.querySelectorAll('.dropdown-trigger');
            const dropdownLinks = this.shadowRoot.querySelectorAll('.dropdown-list .dropdown-link .link-wrapper');
            const dropdownTertiary = this.shadowRoot.querySelectorAll('.cover .tertiary-links .has-dd');
            const topLinks = this.shadowRoot.querySelectorAll('.top-menu .has-dd');
            const sessionMenuItem = sessionStorage.getItem('currentMenuItem');
            console.log('dropdownTrig', dropdownTriggers);
            // Check if session storage has an active menu item
            if (sessionMenuItem != null) {
                dropdownTriggers.forEach(trigger => {
                    var _a, _b, _c, _d;
                    const activeDrop = trigger.textContent;
                    if (activeDrop === sessionMenuItem) {
                        (_a = trigger.parentElement) === null || _a === void 0 ? void 0 : _a.classList.add("active");
                        (_b = trigger.nextElementSibling) === null || _b === void 0 ? void 0 : _b.classList.add("show");
                        (_d = (_c = this.shadowRoot) === null || _c === void 0 ? void 0 : _c.getElementById("navigation")) === null || _d === void 0 ? void 0 : _d.classList.add("dd-open");
                    }
                });
            }
            topLinks.forEach(link => {
                link.addEventListener('click', (event) => {
                    topLinks.forEach(thelink => {
                        if (event.currentTarget !== thelink) {
                            thelink.classList.remove('show');
                        }
                    });
                    if (link) {
                        link.classList.toggle('show');
                    }
                });
                link.addEventListener('mouseover', () => {
                    let maxHeight = 0;
                    const coverItem = link.querySelector(".cover");
                    const theChildren = link.querySelectorAll("quartly");
                    theChildren.forEach(child => {
                        const element = child;
                        const childHeight = element.offsetHeight;
                        if (childHeight > maxHeight) {
                            maxHeight = childHeight;
                        }
                    });
                    coverItem.style.maxHeight = `${maxHeight}px`;
                });
            });
            // Add event listeners to toggle dropdown content
            dropdownTriggers.forEach(trigger => {
                var _a;
                const dropdowns = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.dropdown-content');
                if (dropdowns != null) {
                    trigger.addEventListener('click', (event) => {
                        var _a, _b, _c, _d, _e;
                        const isActive = (_a = trigger.parentElement) === null || _a === void 0 ? void 0 : _a.classList.contains("active");
                        if (isActive !== true) {
                            if (window.innerWidth < 1024) {
                                // FOR MOBILE
                                event.preventDefault();
                            }
                            // Hide all dropdowns, remove active classes.
                            dropdowns.forEach(item => { item.classList.remove('show'); });
                            dropdownLinks.forEach(item => { item.classList.remove('show'); });
                            (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelectorAll('.menu-item').forEach(item => { item.classList.remove('active'); });
                            // Get parent element and add active class.
                            (_c = trigger.parentElement) === null || _c === void 0 ? void 0 : _c.classList.toggle("active");
                            // Get Sibling DropDown element and toggle show.
                            (_e = (_d = this.shadowRoot) === null || _d === void 0 ? void 0 : _d.getElementById("navigation")) === null || _e === void 0 ? void 0 : _e.classList.add("dd-open");
                            // Set Session Storage
                            const theTrigger = trigger.textContent;
                            sessionStorage.setItem('currentMenuItem', theTrigger);
                        }
                    });
                }
            });
            dropdownLinks.forEach(link => {
                link.addEventListener('click', (event) => {
                    dropdownLinks.forEach(thelink => {
                        if (event.currentTarget !== thelink) {
                            thelink.classList.remove('show');
                        }
                    });
                    if (link) {
                        link.classList.toggle('show');
                    }
                });
                link.addEventListener('mouseover', () => {
                    let minHeight = 0;
                    const coverItem = link.querySelector(".cover");
                    const theChildren = link.querySelectorAll("quartly");
                    theChildren.forEach(child => {
                        const element = child;
                        const childHeight = element.offsetHeight;
                        if (childHeight > minHeight) {
                            minHeight = childHeight;
                        }
                    });
                    coverItem.style.minHeight = `${minHeight}px`;
                });
            });
            dropdownTertiary.forEach(ddItem => {
                ddItem.addEventListener('click', (event) => {
                    dropdownTertiary.forEach(thelink => {
                        if (event.currentTarget !== thelink) {
                            thelink.classList.remove('show');
                        }
                    });
                    if (ddItem) {
                        ddItem.classList.toggle('show');
                    }
                });
                ddItem.addEventListener("keypress", function (event) {
                    const keyboardEvent = event;
                    if (keyboardEvent.key === "Enter") {
                        dropdownTertiary.forEach(thelink => {
                            if (event.currentTarget !== thelink) {
                                thelink.classList.remove('show');
                            }
                        });
                        if (ddItem) {
                            ddItem.classList.toggle('show');
                        }
                    }
                });
            });
        }
    }
    toggleMobileMenu() {
        var _a, _b;
        this.mobileMenuIsOpen = !this.mobileMenuIsOpen;
        if (this.mobileMenuIsOpen) {
            disableBodyScroll();
            (_a = this.shadowRoot.querySelector('nav')) === null || _a === void 0 ? void 0 : _a.classList.add("menu-open");
        }
        else {
            enableBodyScroll();
            (_b = this.shadowRoot.querySelector('nav')) === null || _b === void 0 ? void 0 : _b.classList.remove("menu-open");
        }
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('scroll', debounce(() => {
            this.handleScroll();
        }, 100));
    }
    disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
        super.disconnectedCallback();
    }
    renderMobileMenuTrigger() {
        return x `<button class="mobile-menu-trigger" @click="${() => this.toggleMobileMenu()}" aria-label="${this.openMenuText}"><img loading="lazy" alt="" aria-hidden="true" src="${this.mobileMenuIsOpen ? img : img$1}"></button>`;
    }
    renderQuartlyMenu(items) {
        return x `${items.map(item => x `<li><a href="${item.link}" class="dropdown-link">${item.title}</a></li>`)}`;
    }
    renderTertiaryMenu(items) {
        return x `${items.map(item => item.items.length !== 0 ?
            x `<li class="has-dd" tabindex="0"><div class="dropdown-link"><span href="${item.link}" class="tertiary">${item.title}</span> <svg class="desktop" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.99996 3.17419L8.99982 16L6.99982 16L6.99996 3.17423L1.65077 7.75925C1.23145 8.11867 0.600147 8.07011 0.240725 7.65078C-0.118699 7.23146 -0.0701359 6.60016 0.34919 6.24073L7.34919 0.240734C7.72368 -0.0802586 8.27628 -0.0802586 8.65077 0.240734L15.6508 6.24073C16.0701 6.60015 16.1187 7.23145 15.7592 7.65078C15.3998 8.07011 14.7685 8.11867 14.3492 7.75925L8.99996 3.17419Z" fill="#1D1B1F"/></svg> <svg class="mobile" width="18" height="8" viewBox="0 0 18 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 7.00012L8.39999 7.80012C8.75555 8.06679 9.24445 8.06679 9.60001 7.80012L9 7.00012ZM17.6 1.79999C18.0418 1.46862 18.1314 0.841817 17.8 0.399992C17.4686 -0.0418323 16.8418 -0.131369 16.4 0.200006L17.6 1.79999ZM1.60001 0.200006C1.15818 -0.131369 0.531381 -0.0418323 0.200006 0.399992C-0.131369 0.841817 -0.0418323 1.46862 0.399992 1.79999L1.60001 0.200006ZM9.60001 7.80012L17.6 1.79999L16.4 0.200006L8.39999 6.20013L9.60001 7.80012ZM9.60001 6.20013L1.60001 0.200006L0.399992 1.79999L8.39999 7.80012L9.60001 6.20013Z" fill="#1D1B1F"/></svg></div><ul class="quartly"><li><a href="${item.link}" class="dropdown-link"><strong>${item.title}</strong></a>${this.renderQuartlyMenu(item.items)}</li></ul></li>`
            :
                x `<li><a href="${item.link}" class="dropdown-link">${item.title}</a></li>`)}`;
    }
    renderNavigationItem() {
        return this.data.map(item => x `<li class="menu-item"><a href="${item.link}" role="button" class="dropdown-trigger">${item.title} </a>${item.items.length !== 0 ? x `<div class="dropdown-content"><ul class="dropdown-list"><li class="dropdown-link"><div class="link-wrapper"><a href="${item.link}">${item.title}</a></div></li>${this.renderDropdownList(item.items)}</ul></div>` : ''}</li>`);
    }
    renderDropdownList(items) {
        return x `${items.map(item => x `<li class="dropdown-link ${item.items.length !== 0 ? 'has-dd' : ''}"><div class="link-wrapper"><a href="${item.link}" class="${window.location.href.includes(item.link) ? 'active' : ''}">${item.title} </a>${item.items.length !== 0 ? x `<svg width="18" height="8" viewBox="0 0 18 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 7.00012L8.39999 7.80012C8.75555 8.06679 9.24445 8.06679 9.60001 7.80012L9 7.00012ZM17.6 1.79999C18.0418 1.46862 18.1314 0.841817 17.8 0.399992C17.4686 -0.0418323 16.8418 -0.131369 16.4 0.200006L17.6 1.79999ZM1.60001 0.200006C1.15818 -0.131369 0.531381 -0.0418323 0.200006 0.399992C-0.131369 0.841817 -0.0418323 1.46862 0.399992 1.79999L1.60001 0.200006ZM9.60001 7.80012L17.6 1.79999L16.4 0.200006L8.39999 6.20013L9.60001 7.80012ZM9.60001 6.20013L1.60001 0.200006L0.399992 1.79999L8.39999 7.80012L9.60001 6.20013Z" fill="#1D1B1F"/></svg>` : ''}</div>${item.items.length !== 0 ? x `<div class="cover"><ul class="tertiary-links">${this.renderTertiaryMenu(item.items)}</ul></div>` : ''}</li>`)}`;
    }
    renderTopMenu() {
        return this.headerLinksData.map(item => x `<li class="dropdown-link ${item.items.length !== 0 ? 'has-dd' : ''}">${item.folder === true ?
            x `<span class="${window.location.href.includes(item.url) ? 'active' : ''}">${item.text}</span>` :
            x `<div class="link-wrapper"><a href="${item.url}" class="${window.location.href.includes(item.url) ? 'active' : ''}">${item.text}</a></div>`} ${item.items.length !== 0 ? x `<svg width="18" height="8" viewBox="0 0 18 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 7.00012L8.39999 7.80012C8.75555 8.06679 9.24445 8.06679 9.60001 7.80012L9 7.00012ZM17.6 1.79999C18.0418 1.46862 18.1314 0.841817 17.8 0.399992C17.4686 -0.0418323 16.8418 -0.131369 16.4 0.200006L17.6 1.79999ZM1.60001 0.200006C1.15818 -0.131369 0.531381 -0.0418323 0.200006 0.399992C-0.131369 0.841817 -0.0418323 1.46862 0.399992 1.79999L1.60001 0.200006ZM9.60001 7.80012L17.6 1.79999L16.4 0.200006L8.39999 6.20013L9.60001 7.80012ZM9.60001 6.20013L1.60001 0.200006L0.399992 1.79999L8.39999 7.80012L9.60001 6.20013Z" fill="#1D1B1F"/></svg><ul class="tertiary-links">${this.renderTertiaryMenu(item.items)}</ul>` : ''}</li>`);
    }
    render() {
        return x `<nav class="nav-container" id="navigation"><div class="top"><div class="logo"><a href="/" aria-label="Amcare by Convatec"><slot name="logo"></slot></a></div><slot name="phone"></slot>${this.renderMobileMenuTrigger()}</div><div class="nav-wrapper"><div class="main-nav"><ul class="nav-links">${this.renderNavigationItem()}</ul><div class="phone-desktop"><slot name="phone-desktop-label"></slot><slot name="phone-desktop"></slot></div><div class="top-menu"><ul>${this.renderTopMenu()}</ul></div></div></div></nav>`;
    }
}
amcareMainNav.styles = css_248z;
__decorate([
    t()
], amcareMainNav.prototype, "mobileMenuIsOpen", void 0);
__decorate([
    n()
], amcareMainNav.prototype, "closeButtonText", void 0);
__decorate([
    n()
], amcareMainNav.prototype, "openMenuText", void 0);
__decorate([
    n({ type: Object })
], amcareMainNav.prototype, "data", void 0);
__decorate([
    n({ type: Object })
], amcareMainNav.prototype, "headerLinksData", void 0);
customElements.define('amcare-main-nav', amcareMainNav);

export { amcareMainNav };
